import {IExtendedFilterValue} from "@app/interfaces/dtos/IExtendedFilterValue";
import {RouteLocation} from "vue-router";
import {FilterType} from "@domain/enums/FilterType";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import {PortalType} from "@studyportals/domain-client";

export abstract class FilterMapper {
	public abstract filterType: FilterType;
	public abstract readonly isMultiSelect: boolean;

	protected abstract values: IExtendedWithPortalTypeFilterValue[];

	public getAllExtendedFilterValues(portalType?: PortalType): IExtendedFilterValue[] {
		if (!portalType) return this.values;
		return this.values.filter(v => !v.portalTypes || v.portalTypes.includes(portalType));
	}

	public getExtendedFilterValueById(id: string): IExtendedFilterValue | undefined {
		return this.values.find((v) => v.id === id);
	}

	public getExtendedFilterValueByVirtualPath(virtualPath: string): IExtendedFilterValue | undefined {
		return this.values.find((v) => v.virtualPath === virtualPath);
	}

	public getAllVirtualPaths(includeSynonyms: boolean): string[] {
		const paths = [];

		for (const value of this.values) {
			if (value.virtualPath) paths.push(value.virtualPath);
			if (includeSynonyms && value.synonyms) paths.push(...value.synonyms);
		}

		return paths;
	}

	public async getExtendedFilterValuesFromRoute(route: RouteLocation): Promise<IExtendedFilterValue[]> {
		let valueSet = this.getFilterValuesFromRouteParams(new Set<IExtendedWithPortalTypeFilterValue>(), route)
		valueSet = this.getFilterValuesFromRouteQuery(valueSet, route);

		return Array.from(valueSet);
	}

	protected getFilterValuesFromRouteParams(valueSet: Set<IExtendedFilterValue>, route: RouteLocation): Set<IExtendedWithPortalTypeFilterValue> {
		const paramValue = route.params?.[this.filterType];

		if (typeof paramValue === 'string') {
			let value = this.values.find((v) => v.virtualPath === paramValue);
			if (!value) value = this.values.find(v => v.synonyms?.includes(paramValue));

			if (value) valueSet.add(value);
		}

		return valueSet;
	}

	protected getFilterValuesFromRouteQuery(valueSet: Set<IExtendedFilterValue>, route: RouteLocation): Set<IExtendedWithPortalTypeFilterValue> {
		const queryValue = route.query?.[this.filterType];
		if (typeof queryValue === 'string') {
			const ids = queryValue.split(',');

			for (const id of ids) {
				const value = this.values.find((v) => v.id === id);
				if (value) valueSet.add(value);
			}
		}

		return valueSet
	}

}
